import { render, staticRenderFns } from "./GridDisplayOptions.vue?vue&type=template&id=32f462ba&"
import script from "./GridDisplayOptions.vue?vue&type=script&lang=js&"
export * from "./GridDisplayOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports